import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  HostListener,
} from '@angular/core';
import {
  Router,
  NavigationEnd,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
  ResolveStart,
  ResolveEnd,
  NavigationStart,
  Event as NavigationEvent,
} from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSidenav } from '@angular/material';
import { MediaChange, ObservableMedia } from '@angular/flex-layout';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from '../../../services/theme.service';
import PerfectScrollbar from 'perfect-scrollbar';
import { LayoutService } from '../../../services/layout.service';
import { filter } from 'rxjs/operators';
import { AgentProfileService } from '../../../services/agent-profile.service';
import { Observable } from 'rxjs/Rx';
// import { MainLayoutComponent } from '../../../../views/main-layout/main-layout.component'
// import {
//   MatListModule,
//   MatIconModule,
//   MatButtonModule,
//   MatCardModule,
//   MatMenuModule,
//   MatSlideToggleModule,
//   MatGridListModule,
//   MatChipsModule,
//   MatCheckboxModule,
//   MatRadioModule,
//   MatTabsModule,
//   MatInputModule,
//   MatProgressBarModule
//  } from '@angular/material';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.template.html',
  styleUrls: ['./admin-layout.template.scss'],
})
export class AdminLayoutComponent implements OnInit, AfterViewInit {
  public isModuleLoading: Boolean = false;
  private moduleLoaderSub: Subscription;
  private layoutConfSub: Subscription;
  private routerEventSub: Subscription;
  private mediaSub: Subscription;
  // private sidebarPS: PerfectScrollbar;
  private bodyPS: PerfectScrollbar;
  private headerFixedBodyPS: PerfectScrollbar;
  public layoutConf: any = {};
  public notificationsCount: any;
  public notificationsData: any;
  public navRoute;

  constructor(
    private router: Router,
    public translate: TranslateService,
    public themeService: ThemeService,
    private layout: LayoutService,
    private media: ObservableMedia,
    private agentInfoService: AgentProfileService,
  ) {
    this.router.events.subscribe((event: NavigationEvent): void => {
      if (event instanceof NavigationEnd) {
        this.navRoute = this.router.url.split('/')[1];
      }
    });
    // Close sidenav after route change in mobile
    this.routerEventSub = router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((routeChange: NavigationEnd) => {
        this.layout.adjustLayout({ route: routeChange.url });
      });

    // Translator init
    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
  }
  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
    // this.layout.adjustLayout();
    this.navRoute = this.router.url.split('/')[1];
    // FOR MODULE LOADER FLAG
    this.moduleLoaderSub = this.router.events.subscribe(event => {
      if (
        event instanceof RouteConfigLoadStart ||
        event instanceof ResolveStart
      ) {
        this.isModuleLoading = true;
      }
      if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
        this.isModuleLoading = false;
      }
    });
    Observable.interval(3000)
      .flatMap(() => this.agentInfoService.getAgentEvents())
      .subscribe(data => {
        this.agentInfoService.updateAgentEvents(data);
        this.notificationsData = data;
      });
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.layout.adjustLayout(event);
  }

  ngAfterViewInit() {
    this.layoutConfSub = this.layout.layoutConf$.subscribe(change => {
      this.initBodyPS(change);
    });
  }
  initBodyPS(layoutConf: any = {}) {
    if (layoutConf.navigationPos === 'side' && layoutConf.topbarFixed) {
      if (this.bodyPS) this.bodyPS.destroy();
      if (this.headerFixedBodyPS) this.headerFixedBodyPS.destroy();
      /**
       * commented part below is for disabling
       * duplicate of scroll bars in the theme
       * and the web page
       */

      // this.headerFixedBodyPS = new PerfectScrollbar('.rightside-content-hold', {
      //   suppressScrollX: true
      // });
      // this.scrollToTop('.rightside-content-hold');
    } else {
      if (this.bodyPS) this.bodyPS.destroy();
      if (this.headerFixedBodyPS) this.headerFixedBodyPS.destroy();
      // this.bodyPS = new PerfectScrollbar('.main-content-wrap', {
      //   suppressScrollX: true
      // });
      // this.scrollToTop('.main-content-wrap');
    }
  }
  scrollToTop(selector: string) {
    if (document) {
      let element = <HTMLElement>document.querySelector(selector);
      element.scrollTop = 0;
    }
  }
  ngOnDestroy() {
    if (this.moduleLoaderSub) {
      this.moduleLoaderSub.unsubscribe();
    }
    if (this.layoutConfSub) {
      this.layoutConfSub.unsubscribe();
    }
    if (this.routerEventSub) {
      this.routerEventSub.unsubscribe();
    }
  }
  closeSidebar() {
    this.layout.publishLayoutChange({
      sidebarStyle: 'closed',
    });
  }
  displayCounter(count) {
    this.notificationsCount = count;
  }
}
